<template>
  <div class="footer-container">
    <div class="entrance">
      <ul>
        <li v-for="item in entranceList" :key="item.title" @click="() => jump(item)">
          <img :src="item.icon" :alt="item.title" />
          <span>{{ item.title }}</span>
        </li>
      </ul>
    </div>

    <div class="gray">
      <div class="links">
        <span v-for="item in linkList" :key="item.title" @click="() => $router.push(item.url)">
          {{ item.title }}
        </span>
      </div>

      <div class="copy-right">
        <div>Copyright ©2022江苏交通控股有限公司</div>
        <div>
          <span @click="openUrl('http://beian.miit.gov.cn/state/outPortal/loginPortal.action')"
            >苏ICP备10206665号-3</span
          >
        </div>
        <div>
          <span
            @click="
              openUrl('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32010202010562')
            "
            >公安备案号&emsp;32010202010562&emsp;</span
          >
        </div>
        <div>江苏交通控股有限公司党委宣传部&emsp;主办</div>
      </div>
    </div>
  </div>
</template>

<script>
import jkImg from '@/assets/image/jk.png';
import zkptImg from '@/assets/image/zkpt.png';
// import sjjkImg from '@/assets/image/sjjk.png';
import personImg from '@/assets/image/person.png';
import codes from '@/api/codes';
import { configureParams } from '@/assets/js/configureParams';

export default {
  name: 'Footer',
  data() {
    return {
      activeName: '',
      linkList: [
        { title: '法律声明', url: '/law' },
        { title: '联系我们', url: '/contact' },
        { title: '友情链接', url: '/link' },
      ],
      entranceList: [
        { title: 'OA登录', icon: jkImg, url: 'http://sjk.jchc.cn' },
        { title: '采购平台', icon: zkptImg, url: 'https://zbcg.jchc.cn/portal' },
        // { title: '视觉交控', icon: sjjkImg, url: 'https://sjjk.jchc.cn/#/main' },
        { title: '人才中心', icon: personImg },
      ],
      clickTag1: codes.MENU, // 标记点击的是菜单
    };
  },

  mounted() {},

  methods: {
    openUrl(url) {
      window.open(url);
    },

    jump(item) {
      if (item.title === '人才中心') {
        return this.clickMore(131);
      }
      window.open(item.url);
    },

    // 点击更多跳转到当前栏目
    clickMore(menuId) {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
        menuId,
      };
      this.$api.getMenuLevels(replacement).then((data) => {
        this.$router.push({
          path: '/content',
          query: configureParams(data, data, this.clickTag1),
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.footer-container {
  .entrance {
    padding: 0 40px;

    ul {
      border-top: 1px solid #dadada;
      padding: 38px 12px 54px;
      display: flex;
      justify-content: space-between;

      li {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 46px;
          margin-bottom: 19px;
        }
        span {
          font-size: 26px;
          font-weight: 400;
          color: #333333;
          line-height: 37px;
        }
      }
    }
  }

  .gray {
    background: #f5f6f7;
    padding: 68px 130px 62px;

    .links {
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      line-height: 40px;
      text-align: center;

      > span {
        &:nth-child(n + 2) {
          &::before {
            content: '丨';
          }
        }
      }
    }

    .copy-right {
      margin-top: 51px;
      font-size: 26px;
      font-weight: 400;
      color: #aeaeae;
      line-height: 47px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue